import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import "./styles/SkillManagement.css";
import Button from "@mui/material/Button";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import SkillManagementTable from "../components/scripts/SkillManagementTable";
import { useEffect, useState, useRef } from "react";
import Api_Call from "../ApiCall";
import { useSerialIds } from "highcharts";
import info from "../info.json";
const SkillManagement = () => {
  //   const columns = [
  //     {
  //       Header: "Header",
  //       columns: [
  //         {
  //           Header: "Skill",
  //           accessor: "Val",
  //         },
  //         {
  //           Header: "Action",
  //           accessor: "Action",
  //         },
  //
  //     },
  //   ];
  const [tableData, settableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchHeader, setSearchHeader] = useState("");

  console.log(tableData);

  const columns = [
    {
      Header: "Skill",
      accessor: "Title",
    },
    {
      Header: "Active",
      accessor: "isActive",
    },
    {
      Header: "Action",
      accessor: "",
      Cell: () => (
        <span>
          <EditIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              console.log("Edit Clicked");
            }}
          />{" "}
        </span>
      ),
    },
  ];

  const headerRows =
    searchHeader == ""
      ? []
      : tableData.filter((item) => {
          return item.Header.toLowerCase().includes(searchHeader.toLowerCase());
        });
  useEffect(async () => {
    setLoading(true);
    try {
      const api = new Api_Call();
      const data = await api.getData(
        `UI/SKILL-ENROLLMENT`,
        info.BASE_URL_ADMIN
      );
      const obj = data.body[0];
      const dataToTable = Object.keys(obj)
        .map((item) =>
          obj[item]["Skills"].map((item2) => {
            return {
              ...item2,
              Header: item,
              Header_ID: obj[item]["Header_ID"],
            };
          })
        )
        .flat();

      settableData(dataToTable);
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) {
    return (
      <Box className="loader-wrapper">
        <div className="loader"></div>
      </Box>
    );
  }
  return (
    <>
      <Box className="primary-title-new">
        <img src="img/heading-bg.png" />
        <Typography variant="h1">Skill Management</Typography>
      </Box>
      <div className="content-main">
        <div className="user-content-container">
          <div className="tasklist-table specific-table ">
            <Box>
              <SkillManagementTable
                columns={columns}
                tableData={
                  searchHeader == ""
                    ? tableData.sort((a, b) => a.Header_ID - b.Header_ID)
                    : headerRows
                }
                searchHeader={searchHeader}
                setSearchHeader={setSearchHeader}
                settableData={settableData}
              ></SkillManagementTable>
            </Box>
          </div>
        </div>
      </div>
    </>
  );
};

export default SkillManagement;
